<template>
  <v-app light>
    <v-toolbar app clipped-left fixed prominent dark color="teal darken-3">

      <v-btn icon @click.native="back">
        <v-icon>arrow_back</v-icon>
      </v-btn>

      <v-toolbar-title v-text="simulation.label"></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn outline dark class="mr-3 hidden-sm-and-down" @click.native="saveBtn">
        <v-icon left>save</v-icon>
        Salvar
      </v-btn>
      <v-btn outline dark class="mr-3 hidden-sm-and-down" @click.native="graphics">
        <v-icon left>insert_chart</v-icon>
        Gráficos
      </v-btn>
      <v-btn outline dark class="mr-3 ml-0 hidden-sm-and-down" @click.native="cancel">
        <v-icon left>cancel</v-icon>
        Cancelar
      </v-btn>
      <v-btn icon dark class="hidden-md-and-up" @click.native="saveBtn">
        <v-icon>save</v-icon>
      </v-btn>

    </v-toolbar>
    <v-content>
      <v-formulario>
        <v-form class="form" @submit.prevent="grava()" >

          <v-stepper v-model="e6" vertical non-linear>
            <v-stepper-step color=#00695c :complete="e6 > 1" step="1" editable>Dados Básicos</v-stepper-step>
            <v-stepper-content step="1">
                <dadosiniciais ref="myDadosIniciais" />
                  <v-btn type="submit" color=#00695c dark @click="e6 = 2">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 2" step="2" editable>Dados do Rebanho de Reprodução</v-stepper-step>
            <v-stepper-content step="2">
                <dadosrebanhoreproducao ref="myDadosRebanhoReproducao" />
                  <v-btn type="submit" text @click="e6 = 1">Anterior</v-btn>
                  <v-btn type="submit" color=#00695c dark @click="e6 = 3">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 3" step="3" editable>Dados do Rebanho de Recria</v-stepper-step>
            <v-stepper-content step="3">
                <dadosrebanhorecria ref="myDadosRebanhoDeRecria" />
                <v-btn type="submit" text @click="e6 = 2">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 4">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 4" step="4" editable>Dados dos Recursos - Pastagens e Outros</v-stepper-step>
            <v-stepper-content step="4">
                <dadosrecursospastagensoutros ref="myDadosRecursosPastagensOutros" />
                <v-btn type="submit" text @click="e6 = 3">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 5">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 5" step="5" editable>Dados dos Recursos - Instalações e Benfeitorias</v-stepper-step>
            <v-stepper-content step="5">
                <dadosrecursosinstalacoes ref="myDadosRecursosInstalacoes" />
                <v-btn type="submit" text @click="e6 = 4">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 6">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 6" step="6" editable>Dados dos Recursos - Máquinas e Equipamentos</v-stepper-step>
            <v-stepper-content step="6">
                <dadosrecursosmaquinas ref="myDadosRecursosMaquinas"/>
                <v-btn type="submit" text @click="e6 = 5">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 7">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 7" step="7" editable>Dados dos Recursos - Animais</v-stepper-step>
            <v-stepper-content step="7">
                <dadosrecursosanimais ref="myDadosRecursosAnimais"/>
                <v-btn type="submit" text @click="e6 = 6">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 8">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 8" step="8" editable>Dados das Despesas</v-stepper-step>
            <v-stepper-content step="8">
                <dadosdasdespesas ref="myDadosDasDespesas"/>
                <v-btn type="submit" text @click="e6 = 7">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 9">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 9" step="9" editable>Dados das Despesas - Manutenção</v-stepper-step>
            <v-stepper-content step="9">
                <dadosdespesasmanutencao ref="myDadosManutencao"/>
                <v-btn type="submit" text @click="e6 = 8">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 10">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 10" step="10" editable>Dados das Despesas - Animais</v-stepper-step>
            <v-stepper-content step="10">
                <dadosdespesasanimal ref="myDespesasAnimal" />
                <v-btn type="submit" text @click="e6 = 9">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 11">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 11" step="11" editable>Dados das Despesas - Serviços</v-stepper-step>
            <v-stepper-content step="11">
                <dadosdespesaservicos ref="myDespesasServicos" />
                <v-btn type="submit" text @click="e6 = 10">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 12">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 12" step="12" editable>Dados das Receitas - Pró-Labore</v-stepper-step>
            <v-stepper-content step="12">
                <dadosreceitasprolabore ref="myDadosReceitasProLabore" />
                <v-btn type="submit" text @click="e6 = 11">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 13">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 13" step="13" editable>Dados das Receitas - Bovinos para Abate e Consumo Próprio</v-stepper-step>
            <v-stepper-content step="13">
                <dadosreceitasbovinoabate ref="myDadosReceitasBovinoAbate" />
                <v-btn type="submit" text @click="e6 = 12">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 14">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 14" step="14" editable>Dados das Receitas - Bovinos para Outros Destinos</v-stepper-step>
            <v-stepper-content step="14">
                <dadosreceitasbovinooutro ref="myDadosReceitasBovinoOutro" />
                <v-btn type="submit" text @click="e6 = 13">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark @click="e6 = 15">Próximo</v-btn>
            </v-stepper-content>

            <v-stepper-step color=#00695c :complete="e6 > 15" step="15" editable>Outras Receitas</v-stepper-step>
            <v-stepper-content step="15">
                <outrasreceitas ref="myOutrasReceitas" />
                <v-btn type="submit" text @click="e6 = 14">Anterior</v-btn>
                <v-btn type="submit" color=#00695c dark >Salvar</v-btn>
            </v-stepper-content>

          </v-stepper>

          <v-expansion-panel v-model="panel[7]" expand class="panel">
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex md6 text-xs-center>
                  <v-btn color=#00695c dark @click="graphics" >
                    <v-icon left>insert_chart</v-icon>
                    Carregar Gráficos
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-form>
      </v-formulario>
      <message-wrapper ref="message" />
      <dialog-wrapper ref="dialog" />
    </v-content>
  </v-app>
</template>
<script>
/* eslint-disable */
import DadosIniciais from "../components/dados/DadosIniciais.vue";
import DadosRebanhoReproducao from "../components/dados/DadosRebanhoReproducao.vue";
import DadosRebanhoRecria from "../components/dados/DadosRebanhoRecria.vue";
import DadosReceitasProLabore from "../components/dados/DadosReceitasProLabore.vue";
import DadosReceitasBovinoOutro from "../components/dados/DadosReceitasBovinoOutro.vue";
import DadosReceitasBovinoAbate from "../components/dados/DadosReceitasBovinoAbate.vue";
import OutrasReceitas from "../components/dados/OutrasReceitas.vue";
import DadosDasDespesas from "../components/dados/DadosDasDespesas.vue";
import DadosDespesasManutencao from "../components/dados/DadosDespesasManutencao.vue";
import DadosDespesasAnimal from "../components/dados/DadosDespesasAnimal.vue";
import DadosDespesasServicos from "../components/dados/DadosDespesasServicos.vue";
import DadosRecursosPastagensOutros from "../components/dados/DadosRecursosPastagensOutros.vue";
import DadosRecursosInstalacoes from "../components/dados/DadosRecursosInstalacoes.vue";
import DadosRecursosMaquinas from "../components/dados/DadosRecursosMaquinas.vue";
import DadosRecursosAnimais from "../components/dados/DadosRecursosAnimais.vue";

import Formulario from "../class/Formulario.js";
import Dictionary from "../class/Dictionary.js";
import MessageWrapper from '../components/Message.vue';
import DialogWrapper from '../components/Dialog.vue';
import UtilHelper from '../helpers/util';
import timestamp from 'unix-timestamp';

export default {
  components: {
    dadosiniciais: DadosIniciais,
    dadosrebanhoreproducao: DadosRebanhoReproducao,
    dadosrebanhorecria: DadosRebanhoRecria,
    dadosreceitasprolabore: DadosReceitasProLabore,
    dadosreceitasbovinooutro: DadosReceitasBovinoOutro,
    dadosreceitasbovinoabate: DadosReceitasBovinoAbate,
    outrasreceitas: OutrasReceitas,
    dadosdasdespesas: DadosDasDespesas,
    dadosdespesasmanutencao: DadosDespesasManutencao,
    dadosdespesasanimal: DadosDespesasAnimal,
    dadosdespesaservicos: DadosDespesasServicos,
    dadosrecursospastagensoutros: DadosRecursosPastagensOutros,
    dadosrecursosinstalacoes: DadosRecursosInstalacoes,
    dadosrecursosmaquinas: DadosRecursosMaquinas,
    dadosrecursosanimais: DadosRecursosAnimais,
    MessageWrapper,
    DialogWrapper
  },

  mixins: [
    UtilHelper
  ],

  $_veeValidate: {
    validator: "new"
  },

  data: () => ({
    formulario: new Formulario(),
    forme: "",
    none: 0,
    snackbar: false,
    panel: [0, 0, 0, 0, 0, 0, 0, 0, 0],
    e6: 1,
    simulation: null,
  }),
  beforeMount () {
    this.simulation = this.instantiateSimulationHelper()
  },
  mounted () {
    var self = this
    this.$db.simulation.get(this.$route.params.code, function (s) {
      self.simulation = s
    })
    this.$validator.localize("pt", new Dictionary());
 },
  provide() {
    return {
      $validator: this.$validator
    };
  },

  methods: {
    grava() {
          this.$db.simulation.where('code').equals(this.simulation.code).modify({
              dadosIniciais: this.$refs.myDadosIniciais.formulario,
              rebanhoReproducao: this.$refs.myDadosRebanhoReproducao.formulario,
              rebanhoRecria: this.$refs.myDadosRebanhoDeRecria.formulario,
              bovinoAbate: this.$refs.myDadosReceitasBovinoAbate.formulario,
              bovinoOutro: this.$refs.myDadosReceitasBovinoOutro.formulario,
              proLabore: this.$refs.myDadosReceitasProLabore.formulario,
              outrasReceitas: this.$refs.myOutrasReceitas.formulario,
              dadosDasDespesas: this.$refs.myDadosDasDespesas.formulario,
              dadosManutencao: this.$refs.myDadosManutencao.formulario,
              dadosDespesasAnimal: this.$refs.myDespesasAnimal.formulario,
              dadosDespesasServicos: this.$refs.myDespesasServicos.formulario,
              dadosRecursosPastagensOutros: this.$refs.myDadosRecursosPastagensOutros.formulario,
              dadosRecursosInstalacoes: this.$refs.myDadosRecursosInstalacoes.formulario,
              dadosRecursosMaquinas: this.$refs.myDadosRecursosMaquinas.formulario,
              dadosRecursosAnimais: this.$refs.myDadosRecursosAnimais.formulario,
              changed: Math.floor(timestamp.now())
            })
    },

    cancel () {
      this.$router.push({ path: '/home' })
    },

    back () {
      this.grava();
      this.$router.push({ path: '/home' })
    },

    graphics () {
      this.grava();
      this.$router.push({ path: '/graficos/' + this.simulation.code });
    },

    saveBtn () {
      this.grava();
      this.$refs.message.open('Dados salvos!', 'success');
    },
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>